export function getCookie(name: string): string | null {
  const cookies = document.cookie
    .split('; ')
    .map((cookie) => cookie.split('='))
    .reduce(
      (acc, [key, ...value]) => {
        acc[key] = decodeURIComponent(value.join('='));
        return acc;
      },
      {} as Record<string, string>,
    );

  return cookies[name] || null;
}

export function deleteCookies(cookieNames: string[]) {
  cookieNames.forEach((cookieName) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
}
